import React from 'react';

interface CircularProgressProps {
  size?: number;
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  className?: string;
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  size = 40,
  color = 'primary',
  className = '',
}) => {
  const colorClasses = {
    primary: 'text-blue-600',
    secondary: 'text-gray-600',
    error: 'text-red-600',
    warning: 'text-yellow-600',
    info: 'text-blue-500',
    success: 'text-green-600',
  };

  return (
    <div className={`inline-block ${className}`}>
      <svg
        className={`animate-spin ${colorClasses[color]}`}
        style={{ width: size, height: size }}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );
};

export default CircularProgress;

